const LEGACY_CLIENT_TOKEN_KEYS = ['labClientTokens', 'clientTokens'] as const;

export function purgeLegacyClientTokens(): void {
  for (const key of LEGACY_CLIENT_TOKEN_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      // Storage throws in private mode or when blocked; app start must not fail on it.
    }
  }
}
